module.exports = __webpack_public_path__ + "static/media/jpmorgan-logo.5e0b4a0a.png";